export const brandCode = {
  Lyria: 'Lyria',
  Eurostar: 'Eurostar',
  SNCF: 'SNCF',
  INOUI: 'TGV INOUI',
  SNCB: 'SNCB',
  DB: 'DB',
  ICE: 'ICE',
  IC: 'IC',
  NS: 'NS'
};

export const DB_BRAND_CODES = [brandCode.DB, brandCode.ICE, brandCode.IC];
